/**
 * The pinned locale for human-facing text: day-before-month dates and a
 * 24-hour clock, on the server and in the browser alike, so what a person
 * reads never depends on the host's own locale.
 *
 * For display only. Identifiers, API and database fields, logs, URLs,
 * protocol serialisation and export columns stay locale-independent and
 * machine-stable.
 */
export const APP_LOCALE = "en-GB";
